import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)
import store from '@/store';
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
// Router.selfaddRoutes = function (params){
//   Router.matcher = new Router().matcher;
//   Router.addRoutes(params)
// }
 const  routes=[

  {
    path:'/',
    redirect:{
      name:'home',
    },
    meta: {
      title:'仿制药-首页',
      keepAlive: false
    }
  },
  {
    path:'/home',
    name:'home',
    component:(resolve) => require(['@/pages/home/index'],resolve),
    meta: {
      title:'仿制药-首页',
      keepAlive: false
    }
  },
  {
    path:'/homes',
    name:'homes',
    component:(resolve) => require(['@/pages/homes/index'],resolve),
    meta: {
      title:'仿制药-数据总览',
      keepAlive: false
    }
  },
  {
    path:'/searchQuery',
    name:'searchQuery',
    component:(resolve) => require(['@/pages/searchQuery/index'],resolve),
    meta: {
      title:'仿制药-检索查询',
      keepAlive: false
    }
  },
  {
    path:'/firstPass',
    name:'firstPass',
    component:(resolve) => require(['@/pages/firstPass/index'],resolve),
    meta: {
      title:'仿制药-三年首过',
      keepAlive: false
    }
  },
  {
    path:'/policy',
    name:'policy',
    component:(resolve) => require(['@/pages/policy/index'],resolve),
    meta: {
      title:'仿制药-新闻政策',
      keepAlive: false
    }
  },
  {
    path:'/promptPag',
    name:'promptPag',
    component:(resolve) => require(['@/pages/promptPag/index'],resolve),
    meta:{
      keepAlive: false
    }
  },
  {
    path:'/evaluation',//一致性评价
    name:'evaluation',
    component:(resolve) => require(['@/pages/evaluation/index'],resolve),
    meta: {
      title:'仿制药-一致性评价进展',
      keepAlive: false
    }
  }
  ,
  {
    path:'/preparation',//参比制剂
    name:'preparation',
    component:(resolve) => require(['@/pages/preparation/indexs'],resolve),
    meta: {
      title:'仿制药-参比制剂',
      keepAlive: true
    }
  },
  {
    path:'/medicinal',//上市药品目录
    name:'medicinal',
    component:(resolve) => require(['@/pages/medicinal/index'],resolve),
    meta: {
      title:'仿制药-上市药品目录集',
      keepAlive: true
    }
  },
  {
    path:'/base',//上市药品目录
    name:'base',
    component:(resolve) => require(['@/pages/base/index'],resolve),
    meta: {
      title:'仿制药-基药目录',
      keepAlive: true
    }
  },
  {
    path:'/insurance',//上市药品目录
    name:'insurance',
    component:(resolve) => require(['@/pages/insurance/index'],resolve),
    meta: {
      title:'仿制药-医保目录',
      keepAlive: true
    }
  },
  {
    path:'/daily',
    name:'daily',
    component:(resolve) => require(['@/pages/monitor/daily'],resolve),
    meta: {
      title:'数据监控',
      keepAlive: false
    }
  },
  {
    path:'/weeks',
    name:'weeks',
    component:(resolve) => require(['@/pages/monitor/weeks'],resolve),
    meta: {
      title:'数据监控',
      keepAlive: false
    }
  },
  {
    path:'/preparationDetail/:id',//参比制剂
    name:'preparationDetail',
    component:(resolve) => require(['@/pages/preparation/detail'],resolve),
    meta: {
      title:'仿制药-参比制剂',
      keepAlive: false
    }
  },
   {
     path:'/preparationsDetail/:id',//参比制剂
     name:'preparationsDetail',
     component:(resolve) => require(['@/pages/preparation/details'],resolve),
     meta: {
       title:'仿制药-参比制剂',
       keepAlive: false
     }
   },
  {
    path:'/medicinalDetail/:id',//上市药品目录
    name:'medicinalDetail',
    component:(resolve) => require(['@/pages/medicinal/detail'],resolve),
    meta: {
      title:'仿制药-上市药品目录集',
      keepAlive: false
    }
  },
  {
    path:'/baseDetail/:id',//上市药品目录
    name:'baseDetail',
    component:(resolve) => require(['@/pages/base/detail'],resolve),
    meta: {
      title:'仿制药-基药目录',
      keepAlive: false
    }
  },
  {
    path:'/insuranceDetail/:id',//上市药品目录
    name:'insuranceDetail',
    component:(resolve) => require(['@/pages/insurance/detail'],resolve),
    meta: {
      title:'仿制药-医保目录',
      keepAlive: false
    }
  },
  {
    path:'/drugSearch/:drugName',//品种检索结果页
    name:'drugSearch',
    component:(resolve) => require(['@/pages/searchQuery/components/drugSearch'],resolve),
    meta: {
      title:'仿制药-一致性评价进展',
      keepAlive: false
    }
  },
  {
    path:'/companySearch/:companyName',//企业检索结果页
    name:'companySearch',
    component:(resolve) => require(['@/pages/searchQuery/components/companySearch'],resolve),
    meta: {
      title:'仿制药-一致性评价进展',
      keepAlive: false
    }
  }
]
let router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
});
// 全局导航守卫

router.beforeEach((to, from, next) => {
  // 对组件进行动态缓存
  if (to.name === 'preparation'||to.name === 'medicinal'||to.name === 'base'||to.name === 'insurance') {
    store.commit('iskeepAlive', to.name);
    next();
  } else {
    next();
  }
})
  export default router;




// WEBPACK FOOTER //
// ./src/router/index.js